import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyReportsConfigRoute: InvariantJiraRoute = {
	name: 'legacy-reports-configure',
	path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
	query: ['reportKey'],
};
